import React from "react";
import pic1 from "../assets/images/65ba9cb5d2bca0fcd4f6253c_Rating.svg";

function Hero() {
  return (
    <section className="hero" id="hero">
      <div className="hero__content">
        <h1 className="hero__title">
          ЛIДЕРИ ЗА ОБСЯГАМИ <br />
          <span className="hero__highlight">НАЛИТОГО ТРАФIКУ</span>
        </h1>
        <p className="hero__subtitle">
          НЕВПИННО
          <span className="hero__image">
            <img src={pic1} alt="Иконка" />
          </span>
          <span className="hero__red">ЗАДАЄМО</span> ТРЕНДИ В
          AFFILIATE-ІНДУСТРІЇ
        </p>
        <a href="" className="hero__cta">
          <span className="hero__cta-text">ПРИЄДНАТИСЬ ДО НАС</span>

          <span className="hero__cta-plus">+</span>
        </a>
      </div>
    </section>
  );
}

export default Hero;
